import React from "react";

// IMPORTANT: Field is defined at module scope so React preserves the input's
// identity across parent re-renders. Inline `const Field = () => ...` inside a
// parent component causes the input to unmount on every keystroke — which on
// mobile shows up as "keyboard closes after each letter".

export function Field({ label, required, hint, error, children, testid }) {
  return (
    <div className="space-y-1.5" data-testid={testid ? `field-${testid}` : undefined}>
      <label className="block text-[10px] tracking-overline uppercase font-bold text-slate-600">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
      {hint && !error && <p className="text-xs text-slate-500">{hint}</p>}
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
}

export function TextInput({ value, onChange, type = "text", placeholder, testid, autoComplete, inputMode, ...rest }) {
  return (
    <input
      type={type}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoComplete={autoComplete}
      inputMode={inputMode}
      className="w-full px-4 py-3 border border-slate-300 focus:border-navy focus:ring-1 focus:ring-navy outline-none rounded-sm bg-white text-navy-deep"
      data-testid={testid}
      {...rest}
    />
  );
}

export function TextArea({ value, onChange, rows = 6, placeholder, testid, ...rest }) {
  return (
    <textarea
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      rows={rows}
      placeholder={placeholder}
      className="w-full px-4 py-3 border border-slate-300 focus:border-navy focus:ring-1 focus:ring-navy outline-none rounded-sm bg-white text-navy-deep leading-relaxed resize-y"
      data-testid={testid}
      {...rest}
    />
  );
}
